import { render, staticRenderFns } from "./InvitationAlertMessage.vue?vue&type=template&id=4d96d1c0&scoped=true&"
import script from "./InvitationAlertMessage.vue?vue&type=script&lang=js&"
export * from "./InvitationAlertMessage.vue?vue&type=script&lang=js&"
import style0 from "./InvitationAlertMessage.vue?vue&type=style&index=0&id=4d96d1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d96d1c0",
  null
  
)

export default component.exports